export const PARTNER_MAPPING = {
  SID1: { index: 0, name: "Shareholder 1" },
  SID2: { index: 1, name: "Shareholder 2" }
};

export const SHAREHOLDER_VERIFICATION_RELATED_FIELDS = [
  "salutation",
  "kycDetails.dateOfBirth",
  "kycDetails.emirateIdDetails.eidNumber",
  "kycDetails.emirateIdDetails.eidExpiryDt",
  "kycDetails.passportDetails[0].passportNumber",
  "kycDetails.passportDetails[0].passportExpiryDate",
  "kycDetails.passportDetails[0].passportIssueDate",
  "mothersMaidenName",
  "placeOfBirth"
];

export const SHAREHOLDER_CONTACT_FIELDS = [
  "contactDetails.primaryMobileNo",
  "contactDetails.primaryEmail"
];

export const MIN_SHAREHOLDER_PERCENTAGE = 25;

export const UAE_SHAREHOLDER_PERCENTAGE = 51;

export const SIGNATORY_SAME_VALUE_SELECTED_VALIDATION_MSG =
  "Both shareholders cannot have the same rights. Please adjust this selection or revisit previous shareholders rights to proceed.";

export const PARTNER_SHAREHOLDER_PERCENTAGE_VALIDATION_MSG =
  "The combined ownership percentage must be equal to 100%. Please adjust the values accordingly.";

export const UNIQUE_EMAIL_VALIDATION_MSG =
  "The email address is already in use by the other shareholder/company. Please provide a different email to proceed.";

export const UNIQUE_PHONE_VALIDATION_MSG =
  "The mobile number is already in use by the other shareholder/company. Please provide a different number to proceed.";

export const NON_SIGNATORY_EMAIL_SAME_AS_APPLICATION_VALIDATION_MSG =
  "Non-signatory email cannot be same as company email";

export const NON_SIGNATORY_PHONE_SAME_AS_APPLICATION_VALIDATION_MSG =
  "Non-signatory mobile number cannot be same as company mobile number";
